import { render } from "./VUEComponenteGraficoAccSupSoglie.vue?vue&type=template&id=98ada950"
import script from "./VUEComponenteGraficoAccSupSoglie.vue?vue&type=script&lang=js"
export * from "./VUEComponenteGraficoAccSupSoglie.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__